import React, { useEffect, useState } from "react";
import api, { GALLERY_CATEGORIES, fileUrl } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Layout";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";

export default function Gallery() {
  const [photos, setPhotos] = useState([]);
  const [cat, setCat] = useState("सभी");
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/gallery").then((res) => setPhotos(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = cat === "सभी" ? photos : photos.filter((p) => p.category === cat);

  return (
    <div>
      <PageHeader testId="gallery-header" title="फोटो गैलरी" subtitle="फाउंडेशन की गतिविधियों, कार्यक्रमों एवं क्षेत्र भ्रमण की तस्वीरें" />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="flex gap-2 flex-wrap mb-8">
          {["सभी", ...GALLERY_CATEGORIES].map((c) => (
            <button key={c} data-testid={`gallery-cat-${c}`} onClick={() => setCat(c)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                cat === c ? "bg-[#0a2540] text-white" : "bg-white border border-amber-200 text-[#0a2540] hover:bg-amber-50"
              }`}>{c}</button>
          ))}
        </div>

        {loading ? (
          <div className="text-center py-20 text-slate-400">लोड हो रहा है...</div>
        ) : filtered.length > 0 ? (
          <div className="columns-2 sm:columns-3 lg:columns-4 gap-4 space-y-4">
            {filtered.map((p) => (
              <button key={p.id} data-testid={`gallery-photo-${p.id}`} onClick={() => setActive(p)}
                className="block w-full rounded-xl overflow-hidden card-hover break-inside-avoid group relative">
                <img src={fileUrl(p.image_url)} alt={p.title} className="w-full object-cover" />
                {p.title && (
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                    <span className="text-white text-sm font-medium text-right">{p.title}</span>
                  </div>
                )}
              </button>
            ))}
          </div>
        ) : (
          <EmptyState icon="images" message={photos.length ? "इस श्रेणी में कोई तस्वीर नहीं मिली।" : "अभी तक कोई तस्वीर नहीं जोड़ी गई है।"} />
        )}
      </section>

      <Dialog open={!!active} onOpenChange={() => setActive(null)}>
        <DialogContent className="max-w-4xl w-[95vw] p-0 bg-black border-0 overflow-hidden [&>button.absolute]:bg-black/60 [&>button.absolute]:text-white [&>button.absolute]:rounded-full [&>button.absolute]:w-9 [&>button.absolute]:h-9 [&>button.absolute]:flex [&>button.absolute]:items-center [&>button.absolute]:justify-center [&>button.absolute]:opacity-100" data-testid="gallery-lightbox">
          {active && (
            <div className="relative">
              <img src={fileUrl(active.image_url)} alt={active.title} className="w-full max-h-[85vh] object-contain" />
              {active.title && (
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5 text-white">
                  <p className="font-serif-deva text-lg">{active.title}</p>
                  <p className="text-sm text-amber-300">{active.category}</p>
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
